import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  DashboardMetric,
  DashboardMetricParams,
  getDashboardMetricById,
  getDashboardMetrics,
  getTopCompanies,
  getTopOrganizationsMetrics,
  TopMetricParams,
  TopOrganization,
} from '@/services/Dashboard/dashboard.service';

export const dashboardApiSlice = createApi({
  reducerPath: 'dashboardApi',
  tagTypes: ['DashboardMetrics', 'TopOrganizations'],
  baseQuery: fakeBaseQuery(),
  endpoints: (builder) => ({
    getDashboardMetrics: builder.query<DashboardMetric, DashboardMetricParams | undefined>({
      queryFn: async (params) => {
        try {
          const data = await getDashboardMetrics(params);
          return { data };
        } catch (error) {
          return { error: { status: 'FETCH_ERROR', error: String(error) } };
        }
      },
      providesTags: ['DashboardMetrics'],
    }),

    getDashboardMetricById: builder.query<DashboardMetric, string | void>({
      queryFn: async (id) => {
        if (!id) {
          try {
            const data = await getDashboardMetrics();
            return { data };
          } catch (error) {
            return { error: { status: 'FETCH_ERROR', error: String(error) } };
          }
        }

        try {
          const data = await getDashboardMetricById(id);
          return { data };
        } catch (error) {
          return { error: { status: 'FETCH_ERROR', error: String(error) } };
        }
      },
      providesTags: ['DashboardMetrics'],
    }),
    getTopOrganizations: builder.query<
      TopOrganization[],
      { id: string; filter?: TopMetricParams | undefined }
    >({
      queryFn: async ({ id, filter }) => {
        const data = await getTopOrganizationsMetrics(id, filter);
        return { data };
      },
      providesTags: ['TopOrganizations'],
    }),
    getTopCompanies: builder.query<
      TopOrganization[],
      {
        id: string;
        organizationId: string;
        filter?: TopMetricParams | undefined;
      }
    >({
      queryFn: async ({ organizationId, filter }) => {
        const data = await getTopCompanies(organizationId, filter);
        return { data };
      },
      providesTags: ['TopOrganizations'],
    }),
  }),
});

export const {
  useGetDashboardMetricsQuery,
  useGetDashboardMetricByIdQuery,
  useGetTopOrganizationsQuery,
  useGetTopCompaniesQuery,
} = dashboardApiSlice;
